import React from "react"
import PropTypes from "prop-types"
import StatCard from "components/cards/StatCard"
import theme from "styles/theme"

const StatsBlock = ({ stats }) => (
  <div
    css={{
      display: "grid",
      gridTemplateColumns: `repeat(${stats.length}, minmax(auto, 364px))`,
      justifyContent: "center",
      gridGap: 38,
      margin: "60px auto",
      maxWidth: 1140,
      [theme.tablet]: {
        gridTemplateColumns:
          stats.length > 1
            ? `repeat(2, minmax(auto, 305px))`
            : "minmax(auto, 305px)",
        gridGap: 10,
        "& > :last-child": stats.length % 2 && {
          gridColumn: "1 / -1",
          maxWidth: 305,
          margin: "0 auto",
        },
      },
      [theme.mobile]: {
        gridTemplateColumns: "1fr",
        maxWidth: 300,
      },
    }}
  >
    {stats.map((item, index) => (
      <StatCard key={index} {...item} />
    ))}
  </div>
)

StatsBlock.propTypes = {
  stats: PropTypes.arrayOf(PropTypes.shape(StatCard.propTypes)).isRequired,
}

export default StatsBlock
